export default "__VITE_ASSET__DUexCNV6__"